import * as API from '@/services/API';

export default {
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/paperwork-set/${query}`);
  },
  get(id) {
    return API.apiClient.get(`/paperwork-set/${id}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/paperwork-set`, data);
    } else {
      return API.apiClient.put(`/paperwork-set/${id}`, data);
    }
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async delete(id) {
    return API.apiClient.delete(`/paperwork-set/${id}`);
  }
};
